import React, { memo } from 'react';
import Dropzone from 'react-dropzone';
import FileRow from '../FileRow/FileRow';

const UploadCnab400 = ({ files, isUploading, deleteFile, retryUpload, filesAcceptedHandler }) => {
  return (
    <div className="upload-step">
      <div className="body">
        <div className="margin-zero">
          <Dropzone onDropAccepted={filesAcceptedHandler} disabled={isUploading} noDrag={false}>
            {({ getRootProps, getInputProps, isDragActive }) => (
              <section>
                <div {...getRootProps()} className={`dropzone ${isUploading ? 'disabled' : ''}`}>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <h4>Solte o arquivo aqui...</h4>
                  ) : (
                    <h4>
                      <span>
                        <i className="fas fa-paperclip file-icon" />
                      </span>
                      <span className="link">Selecione</span>
                      <span> o arquivo ou arraste aqui</span>
                    </h4>
                  )}
                </div>
              </section>
            )}
          </Dropzone>

          <div className="file-wrapper">
            {files.map(file => (
              <FileRow key={file.id} file={file} deleteFile={deleteFile} retryUpload={retryUpload} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(UploadCnab400);
